import { TabBuyerProfileProps } from './tab-buyer-profile.type'

import {
  CardDocuments,
  CardOrderProfile,
  CardOrderProfileStatusHistory,
  LogisticFormTabsEnum,
} from '@/components'
import { useParamsState } from '@/helpers'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { OrderLogisticDrawerForm } from '../../../components'
import styles from './tab-buyer-profile.module.css'

export const TabBuyerProfile = ({
  saleOrder,
  isLoading,
}: TabBuyerProfileProps) => {
  const { t } = useTranslation('screenOrderCenterPage')

  const [queryParams, setQueryParams] = useParamsState({
    form: '',
  })

  const documents = useMemo(() => {
    const docs = []

    if (saleOrder?.buyer?.taxSituation) {
      docs.push({
        title: t('orderCenterShowTabProfileTaxSituationTitle'),
        file: saleOrder.buyer.taxSituation,
      })
    }

    return docs
  }, [saleOrder])

  return (
    <>
      <div className={styles.container}>
        <div>
          <CardOrderProfile
            isLoading={isLoading}
            buyer={saleOrder?.buyer}
            saleOrderUuid={saleOrder?.uuid}
          />

          <CardOrderProfileStatusHistory
            isLoading={!!isLoading}
            taxStatusHistory={saleOrder?.buyer?.statusHistory}
          />
        </div>

        <div>
          <CardDocuments isLoading={!!isLoading} data={documents} />
        </div>
      </div>

      {saleOrder && (
        <OrderLogisticDrawerForm
          isOpen={!!queryParams.form}
          initialValues={saleOrder}
          onHandleClose={() => setQueryParams({ form: '' })}
          initialTab={
            (queryParams.form as keyof typeof LogisticFormTabsEnum) ||
            'transport'
          }
        />
      )}
    </>
  )
}
